import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LyButtonModule} from "@alyle/ui/button";
import {LyIconModule} from "@alyle/ui/icon";
import {LyTypographyModule} from "@alyle/ui/typography";
import {LySliderModule} from "@alyle/ui/slider";
import {LyImageCropperModule} from "@alyle/ui/image-cropper";

const alyleUiModules = [
    LyButtonModule,
    LyIconModule,
    LyTypographyModule,
    LyImageCropperModule,
    LySliderModule,
];

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        alyleUiModules
    ],
    exports: [
        alyleUiModules
    ]
})
export class AlyleUiModule {
}
